import React, { useEffect, useState } from "react";
import { Row, Col, Space, Form, Input, Button, Select, message } from "antd";
import { postAPI, getAPI } from "../../../config/api/apiConfig";
import { useDispatch, useSelector } from "react-redux";
import { setDeviceAdded } from "../../../redux/feature/device";

const { Option } = Select;

const RegisterDevice1 = () => {
  const token = useSelector((state) => state.authenticate.userToken);
  const [isDeviceAdded, setIsDeviceAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userOrganisation, setUserOrganisation] = useState(null);
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const userId = useSelector((state) => state.authenticate.userId);

  useEffect(() => {
    console.log("Fetching organisation data for userId:", userId);
    getAPI(`/get-organisation-by-user/${userId}`)
      .then((response) => {
        console.log("API Response: ", response);
        const { data } = response.data;
        setUserOrganisation(data);
        console.log("Organisation data set successfully:", data);
        form.setFieldsValue({
          organisationName: data.organisationName,
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [userId, form]);

  const addDevice = async (values) => {
    console.log("Form values before submission:", values);
    const formValues = {
      ...values,
      userId: parseInt(userId),
    };

    setIsDeviceAdded(false);
    try {
      setLoading(true);

      const registerDevice = await postAPI(
        `/register-device/${parseInt(userId)}`,
        formValues
      );

      const { data, success } = registerDevice.data;
      if (success) {
        message.success("Device Added Successfully");
        dispatch(setDeviceAdded(data));
        setIsDeviceAdded(success);
        setLoading(false);

        // Reset all fields except organisationName
        form.resetFields(["deviceName", "deviceType", "deviceModel"]);
      }
    } catch (err) {
      if (err) {
        setIsDeviceAdded(false);
        setLoading(false);
        message.error(err.response?.data?.message);
        console.log(err);
      }
    }
  };

  return (
    <div
      style={{
        padding: 0,
        margin: 0,
       
      }}
    >
      <div className="row-vend" style={{ width: "100%", overflowX: "hidden" }}>
        <div className="device-form">
          <Space
            direction="vertical"
            style={{
              width: "100%",
            }}
          ></Space>

          <Form
            form={form}
            onFinish={addDevice}
            layout="vertical"
            className="row-col"
          >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24}>
                <Form.Item
                  className="username input-device"
                  label={(
                    <span>
                      Device Name
                      <span style={{ fontSize: 'smaller', color: 'green' }}>
                        (Device Name & Device Model inputted will be captured on the certificate)
                      </span>
                    </span>
                  )}
                  name="deviceName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your name!",
                    },
                  ]}
                >
                  <Input placeholder="Enter your Device Name" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24}>
                <Form.Item
                  className="username input-device"
                  label="Device Type"
                  name="deviceType"
                  rules={[
                    {
                      required: true,
                      message: "Please select your device type!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select a Device Type"
                    style={{ fontWeight: "600", width: "100%" }}
                  >
                    <Option value="single">Single</Option>
                    <Option value="multiple">Multiple</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24}>
                <Form.Item
                  className="username input-device"
                  label="Device Model"
                  name="deviceModel"
                  rules={[
                    {
                      required: true,
                      message: "Please input Device Model",
                    },
                  ]}
                >
                  <Input placeholder="Device Model" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24}>
                <Form.Item
                  className="username input-device"
                  label="Organisation Name"
                  name="organisationName"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Organisation Name",
                    },
                  ]}
                >
                  <Input placeholder="Organisation Name" disabled />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} >
                <Form.Item
                  name="userId"
                  style={{ display: "none" }}
                  initialValue={parseInt(userId)}
                >
                  <Input defaultValue={parseInt(userId)} />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="nibss-form-btn reg-btn"
                    loading={loading}
                  >
                    Add Device
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default RegisterDevice1;
